export default __webpack_public_path__ + "static/media/ticket23.c731c727.jpg";